import { Button, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import { PhilModalVariant } from '@farmasiet/iframe-messages';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { Key } from 'ts-key-enum';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { CustomerSupportContactInfo } from '../CustomerSupportContactInfo/CustomerSupportContactInfo';

interface IErrorViewProps {
    hideModal: () => void;
    variant?: PhilModalVariant;
    customerServiceLabel: string;
    customerServicePhoneNumber: string;
    customerServiceUrl: string;
    buttonKeyDownHandle: () => void;
}

export const ErrorView = (props: IErrorViewProps) => {
    const errorViewImage = '/dist/assets/images/error-phil-connection.svg';
    const sideModalCssClass = props.variant !== PhilModalVariant.Center ? 'ErrorView__SideModal' : '';
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!rootRef.current) return;
        const closeButton = rootRef.current.querySelector('button');
        if (!closeButton) return;
        closeButton.focus();

        const handleOnKeyDown = (e: KeyboardEvent) => {
            if (e.key === Key.Escape) {
                props.hideModal();
            } else if (e.key === Key.Tab && e.shiftKey) {
                e.preventDefault();
                props.buttonKeyDownHandle();
            }
        };

        closeButton.addEventListener('keydown', handleOnKeyDown);

        return () => {
            closeButton?.removeEventListener('keydown', handleOnKeyDown);
        };
    }, []);

    return (
        <div className={classNames('ErrorView__Container', sideModalCssClass)} ref={rootRef}>
            {props.variant !== PhilModalVariant.Center && (
                <div className="ErrorView__HeadingContainer ErrorView__HeadingContainer--Border">
                    <button className="ErrorView__CloseButton" onClick={props.hideModal} type="button">
                        <span className="visuallyHidden">{getTranslation(keys['modal.close'])}</span>
                    </button>
                </div>
            )}
            <div className="ErrorView__HeadingContainer--SideModal">
                <h2 className="ErrorView__Heading">{getTranslation(keys['checkout.error.generic'])}</h2>
                <div className="ErrorView__Image">
                    <img data-src={errorViewImage} alt="" className="lazyload" />
                </div>
                <p className="ErrorView__Description">{getTranslation(keys['modal.errorInfo'])}</p>
                <div className="ErrorView__Buttons">
                    <Button
                        variant={ButtonVariant.Link}
                        size={ButtonSize.Medium}
                        className={'ErrorView__GoBackButton'}
                        onClick={() => props.hideModal()}
                        type="button"
                    >
                        {getTranslation(keys['modal.goBack'])}
                    </Button>
                </div>
            </div>
            {props.variant !== PhilModalVariant.Center && (
                <CustomerSupportContactInfo
                    customerServiceLabel={props.customerServiceLabel}
                    customerServicePhoneNumber={props.customerServicePhoneNumber}
                    customerServiceUrl={props.customerServiceUrl}
                    errorView
                    hideModal={props.hideModal}
                />
            )}
        </div>
    );
};
